<template>
  <div class="custom-modal">
    <div class="custom-modal-content">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
import { classVariableName } from "../../utils";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  mounted() {},
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
});
</script>

<style scoped>
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  min-height: calc(100% - 3.5rem);

  background-color: rgba(20, 20, 20, 0.9); /* Semi-transparent bg */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-content{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
    
}
</style>
